<template>
    <div class="overview-panel">
        <DataPanel :title="title" :reqData="optData" serviceName="queryRobotOverviewData">
            <DataList slot-scope="robotMonitor" :data="robotMonitor.data" />
        </DataPanel>
    </div>
</template>

<script>
import DataPanel from "@/views/zhiji/components/pagesPanel/DataPanel";
import DataList from "./DataList";

export default {
    name: "OverViewPanel",
    props: ["optData"],
    components: {
        DataPanel,
        DataList
    },
    computed: {
        title() {
            return this.$t("zhiji.overview.dataOverview");
        }
    },
    created() {
        this.icons = {
            visitedCount: "url(" + this.zhiji.staticPath() + "overview-spr.png) 0 0",
            userCount: "url(" + this.zhiji.staticPath() + "overview-spr.png) -60px 0",
            askCount: "url(" + this.zhiji.staticPath() + "overview-spr.png) -120px 0",
            inputAskCount: "url(" + this.zhiji.staticPath() + "overview-spr.png) -180px 0",
            answerRate: "url(" + this.zhiji.staticPath() + "overview-spr.png) -240px 0"
        };
    }
};
</script>

<style lang="scss" scope></style>
